module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Thin.c5743404.woff";